import { render, staticRenderFns } from "./Universities.vue?vue&type=template&id=78f80fec&"
import script from "./Universities.vue?vue&type=script&lang=js&"
export * from "./Universities.vue?vue&type=script&lang=js&"
import style0 from "./Universities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports